import { isProbablyEmail, matchesRegex } from "redux-freeform";

const NOT_MULTIPLE_AT = /^[^@]*@?[^@]*$/;

export const emailFormatValidators = [
  isProbablyEmail(),
  matchesRegex(NOT_MULTIPLE_AT)
];

export const EMAIL_FORMAT_ERROR_MESSAGE =
  "Please enter a valid email address in the format user@example.com";

export const emailFormatErrorMessages = {
  [isProbablyEmail.error]: EMAIL_FORMAT_ERROR_MESSAGE,
  [matchesRegex.error]: EMAIL_FORMAT_ERROR_MESSAGE
};
